import "babel-polyfill";
import Vue from "vue";
import VueMeta from "vue-meta";

import App from "./App.vue";
import store from "./store";
import { checkIsMobile } from "./uitls";

Vue.config.productionTip = false;
Vue.prototype.$isMobile = checkIsMobile();
// Vue.prototype.$isMobile = true;
Vue.prototype.$baseURL = process.env.BASE_URL as string;

Vue.use(VueMeta);

import "./i18next";
import i18n from "./vueI18n";

import "./assets/css/font.css";
import "./assets/css/i18n.scss";

new Vue({
  store,
  render: (h) => h(App),
  i18n,
}).$mount("#app");
